import { ActionBar } from '@gogame/components';

import { Breadcrumbs } from './Breadcrumbs';

export const BreadcrumbsBar = ({
  value,
  onChange,
  drillEntityNameFormatter,
}) => {
  return (
    <div style={{ overflow: 'auto' }}>
      <ActionBar dense={true}>
        <Breadcrumbs
          value={value}
          onChange={onChange}
          drillEntityNameFormatter={drillEntityNameFormatter}
        />
      </ActionBar>
    </div>
  );
};
